import { CommonWrap, ComomonAlert, Mb3Box } from "@/PageComponents/common";
import ContentWrap from "@/DocLayout/Content/Index";
import { Box, Link } from "@mui/material";
import { useLocales } from "@/locales";
import { Trans } from "react-i18next";
import { ADMIN_REGISTER_URL, ADMIN_DEV_URL, WEBSITE_URL } from "@/config";
import CodeSnippet from "@/components/CodeSnippet";
import { useContext } from "react";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import ShowTable from "@/DocLayout/Table/index";
// import { merchantStroe } from "@/stores";

export default function QuickStart() {
  return (
    <>
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <NoCodeContent />
          </CommonWrap>
        }
        showBorderBottom={false}
        leftChildrenSx={{
          paddingBottom: "24px",
        }}
      />
      <ContentWrap
        leftSticky={true}
        leftChildren={
          <CommonWrap>
            <SignTemplate />
          </CommonWrap>
        }
        rightChildren={<CodeTemplate />}
        leftChildrenSx={{
          paddingTop: "1px",
        }}
      />
    </>
  );
}

const SignTemplate = () => {
  const { translate, currentLang } = useLocales();
  return (
    <>
      <Mb3Box>
        <Box component={"div"} className="title_0">
          {translate("quick_start.title4_desc1_title")}
        </Box>

        <Box component={"div"} className="desc">
          <Trans
            i18nKey={"quick_start.title4_desc1_desc1"}
            t={translate as any}
          >
            s<strong>s</strong>
            <strong>s</strong>
            <strong>s</strong>s
          </Trans>
        </Box>
        <>
          {currentLang.value !== "en" && (
            <Box component={"div"} className="desc">
              <Trans
                i18nKey={"quick_start.title4_desc1_desc1_1"}
                t={translate as any}
              >
                s<strong>s</strong>
                <strong>s</strong>
                <strong>s</strong>s
              </Trans>
            </Box>
          )}

          <Box
            sx={{
              ul: {
                paddingLeft: "2em",
              },
              li: {
                "::marker": {
                  textIndent: "2em",
                },
              },
            }}
          >
            {currentLang.value === "en" ? (
              <>
                <Box component={"div"} className="desc" mb={3}>
                  {translate("quick_start.title4_desc1_desc1_hmac")}
                </Box>
                {/* <Box component={"div"} className="desc">
                  {translate("quick_start.title4_desc1_desc1_1_1")}
                </Box>
                <Box component={"div"} className="desc">
                  {translate("quick_start.title4_desc1_desc1_1_2")}
                </Box>
                <Box component={"div"} className="desc">
                  {translate("quick_start.title4_desc1_desc1_1_3")}
                </Box> */}
              </>
            ) : (
              <ul>
                <li>
                  <Box component={"div"} className="desc">
                    <Trans
                      i18nKey={"quick_start.title4_desc1_desc1_1_1"}
                      t={translate as any}
                    >
                      s<strong>s</strong>
                      <strong>s</strong>
                      <strong>s</strong>s
                    </Trans>
                  </Box>{" "}
                  <li>
                    <Box component={"div"} className="desc">
                      <Trans
                        i18nKey={"quick_start.title4_desc1_desc1_1_2"}
                        t={translate as any}
                      >
                        s<strong>s</strong>
                        <strong>s</strong>
                        <strong>s</strong>s
                      </Trans>
                    </Box>
                  </li>
                </li>
              </ul>
            )}
          </Box>
          {currentLang.value === "en" && (
            <>
              <Box component={"div"} className="desc" mb={3}>
                {translate("quick_start.title4_desc1_desc1_rsa")}
              </Box>
              {/* <Box component={"div"} className="title_1">
                <Trans
                  i18nKey={"quick_start.title4_desc1_desc1_2"}
                  t={translate as any}
                >
                  s<strong>s</strong>
                  <strong>s</strong>
                  <strong>s</strong>s
                </Trans>
              </Box>
              <Box
                sx={{
                  ul: {
                    paddingLeft: "2em",
                  },
                  li: {
                    "::marker": {
                      textIndent: "2em",
                    },
                  },
                }}
              >
                <ul>
                  <li>
                    <Box component={"div"} className="desc">
                      <Trans
                        i18nKey={"quick_start.title4_desc1_desc1_2_1"}
                        t={translate as any}
                      >
                        s<strong>s</strong>
                        <strong>s</strong>
                        <strong>s</strong>s
                      </Trans>
                    </Box>{" "}
                    <li>
                      <Box component={"div"} className="desc">
                        <Trans
                          i18nKey={"quick_start.title4_desc1_desc1_2_2"}
                          t={translate as any}
                        >
                          s<strong>s</strong>
                          <strong>s</strong>
                          <strong>s</strong>s
                        </Trans>
                      </Box>
                    </li>
                    <li>
                      <Box component={"div"} className="desc">
                        <Trans
                          i18nKey={"quick_start.title4_desc1_desc1_2_3"}
                          t={translate as any}
                        >
                          s<strong>s</strong>
                          <strong>s</strong>
                          <strong>s</strong>s
                        </Trans>
                      </Box>
                    </li>
                    <li>
                      <Box component={"div"} className="desc">
                        <Trans
                          i18nKey={"quick_start.title4_desc1_desc1_2_4"}
                          t={translate as any}
                        >
                          s<strong>s</strong>
                          <strong>s</strong>
                          <strong>s</strong>s
                        </Trans>
                      </Box>
                    </li>
                    <li>
                      <Box component={"div"} className="desc">
                        <Trans
                          i18nKey={"quick_start.title4_desc1_desc1_2_5"}
                          t={translate as any}
                        >
                          s<strong>s</strong>
                          <strong>s</strong>
                          <strong>s</strong>s
                        </Trans>
                      </Box>
                    </li>
                  </li>
                </ul>
              </Box>
              <Box component={"div"} className="desc" mt={3}>
                {translate("quick_start.title4_desc1_desc2_")}
              </Box> */}
            </>
          )}
        </>
      </Mb3Box>

      <ComomonAlert sx={{ mb: 3 }}>
        {translate("quick_start.title4_desc1_desc2")}
      </ComomonAlert>

      <Mb3Box>
        <Box component={"div"} className="title_0">
          {translate("quick_start.title3_desc2_title")}
        </Box>
        <Box component={"div"} className="desc" mb={3}>
          <Trans
            i18nKey={"quick_start.title3_desc2_desc1"}
            t={translate as any}
          >
            Just a placeholder
            <Link
              href={ADMIN_DEV_URL}
              target="_blank"
              className="link"
              underline="always"
            >
              Just a placeholder
            </Link>
          </Trans>
          <br />
          <Trans
            i18nKey={"quick_start.title3_desc2_desc2"}
            t={translate as any}
          >
            Just a placeholder
            <Link
              href={WEBSITE_URL}
              target="_blank"
              className="link"
              underline="always"
            >
              Just a placeholder
            </Link>
          </Trans>
          <br />
          <Trans
            i18nKey={"quick_start.title3_desc2_desc3"}
            t={translate as any}
          >
            Just a placeholder
            <Link
              href={ADMIN_DEV_URL}
              target="_blank"
              className="link"
              underline="always"
            >
              Just a placeholder
            </Link>
          </Trans>
        </Box>
      </Mb3Box>
      <Mb3Box>
        <Box component={"div"} className="title_0">
          {translate("quick_start.title5_desc1_title")}
        </Box>
        <Box component={"div"} className="desc" mb={3}>
          {translate("quick_start.title5_desc1_dsec1")}
        </Box>
      </Mb3Box>

      <ShowTable
        tableData={[
          {
            name: "Appid",
            type: "String",
            is_: `${translate("common.params_is")}`,
            desc: (
              <Trans
                i18nKey={"quick_start.title5_desc1_table_app_id_desc"}
                t={translate as any}
              >
                Just a placeholder
                <Link
                  href={ADMIN_DEV_URL}
                  target="_blank"
                  className="link"
                  underline="always"
                >
                  Just a placeholder
                </Link>
              </Trans>
            ),
          },
          {
            name: "Timestamp",
            type: "String",
            is_: `${translate("common.params_is")}`,
            desc: `${translate(
              "quick_start.title5_desc1_table_timestamp_desc"
            )}`,
          },
          {
            name: "Sign",
            type: "String",
            is_: `${translate("common.params_is")}`,
            desc: (
              <>
                {currentLang.value === "en" ? (
                  <>
                    <Box component={"div"} className="desc" mb={1}>
                      {translate("quick_start.title4_desc1_desc1_sign")}
                    </Box>
                  </>
                ) : (
                  <>
                    <Box component={"div"} className="desc">
                      <Trans
                        i18nKey={"quick_start.title5_desc1_table_sgin_title"}
                        t={translate as any}
                      >
                        s<strong>s</strong>
                        <strong>s</strong>
                        <strong>s</strong>s
                      </Trans>
                    </Box>

                    <Box
                      sx={{
                        ul: {
                          paddingLeft: "2em",
                        },
                        li: {
                          "::marker": {
                            textIndent: "2em",
                          },
                        },
                      }}
                    >
                      <ul>
                        <li>
                          <Box component={"div"} className="desc">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: translate(
                                  "quick_start.title5_desc1_table_sgin_title_desc"
                                ) as any,
                              }}
                            />
                          </Box>
                        </li>
                        <li>
                          <Box component={"div"} className="desc">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: translate(
                                  "quick_start.title5_desc1_table_sgin_title_desc_1"
                                ) as any,
                              }}
                            />
                          </Box>
                        </li>
                      </ul>
                    </Box>

                    <Box component={"div"} className="desc">
                      <Trans
                        i18nKey={"quick_start.title5_desc1_table_sgin_title_1"}
                        t={translate as any}
                      >
                        s<strong>s</strong>
                        <strong>s</strong>
                        <strong>s</strong>s
                      </Trans>
                    </Box>

                    <Box
                      sx={{
                        ul: {
                          paddingLeft: "2em",
                        },
                        li: {
                          "::marker": {
                            textIndent: "2em",
                          },
                        },
                      }}
                    >
                      <ul>
                        <li>
                          <Box component={"div"} className="desc">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: translate(
                                  "quick_start.title5_desc1_table_sgin_title_1_desc"
                                ) as any,
                              }}
                            />
                          </Box>
                        </li>
                        <li>
                          <Box component={"div"} className="desc">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: translate(
                                  "quick_start.title5_desc1_table_sgin_title_1_desc_1"
                                ) as any,
                              }}
                            />
                          </Box>
                        </li>
                      </ul>
                    </Box>
                  </>
                )}
              </>
            ),
          },
        ]}
      />
      <br />
      <ComomonAlert sx={{ mb: 3 }}>
        {translate("quick_start.title5_desc1_dsec2")}
      </ComomonAlert>
    </>
  );
};

const CodeTemplate = () => {
  const { translate } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);

  const codeMap: { [key: string]: any } = {
    javascript: {
      http_ex_code: `var sign = CryptoJS.HmacSHA256('The quick brown fox jumped over the lazy dog.',appSecret).toString();`,
      example_code: `const https = require('https');
const crypto = require('crypto');

const appId ='*** your appId ***';
const appSecret ='*** your appSecret ***';

const path = 'https://ccpayment.com/ccpayment/v2/getCoinList';
const args = '';

const timestamp = Math.floor(Date.now() / 1000);
let signText = appId + timestamp;
if (args) {
  signText += args;
}

const sign = crypto
  .createHmac('sha256', appSecret)
  .update(signText)
  .digest('hex');

const options = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Appid': appId,
    'Sign': sign,
    'Timestamp': timestamp.toString(),
  },
};

const req = https.request(path, options, (res) => {
  let respData = '';

  res.on('data', (chunk) => {
    respData += chunk;
  });

  res.on('end', () => {
    console.log('Response:', respData);
  });
});

req.write(args);
req.end();`,
      example_code2: `const https = require('https');
const crypto = require('crypto');

const appId ='*** your appId ***';
const appSecret ='*** your appSecret ***';

const path = 'https://ccpayment.com/ccpayment/v2/getCoin';
const args = JSON.stringify({ "coinId": 1280 });

const timestamp = Math.floor(Date.now() / 1000);
let signText = appId + timestamp;
if (args) {
  signText += args;
}

const sign = crypto
  .createHmac('sha256', appSecret)
  .update(signText)
  .digest('hex');

const options = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Appid': appId,
    'Sign': sign,
    'Timestamp': timestamp.toString(),
  },
};

const req = https.request(path, options, (res) => {
  let respData = '';

  res.on('data', (chunk) => {
    respData += chunk;
  });

  res.on('end', () => {
    console.log('Response:', respData);
  });
});

req.write(args);
req.end();`,
    },
    python: {
      http_ex_code: `sign_text = app_id + timestamp + PayloadJSON${translate(
        "quick_start.sign_py_desc"
      )}
"""
${translate("common.example")}:
sign_text = "app_id" + "1708659418" + ""
sign_text = "app_id" + "1708659418" + '{"coinId":2372}'
"""

h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
server_sign = binascii.hexlify(h.digest()).decode('utf-8')

`,
      example_code: `# Python 3.9
import json
import time
import hmac
import hashlib
import binascii
import requests

app_id = "*** your app_id ***"
app_secret = "*** your app_secret ***"
url = "https://ccpayment.com/ccpayment/v2/getCoinList"
content = {}  

timestamp = int(time.time())
body = json.dumps(content)
sign_text = f"{app_id}{timestamp}"
if len(body) != 2:
    sign_text = f"{sign_text}{body}"
else:
    body = ""

h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
server_sign = binascii.hexlify(h.digest()).decode('utf-8')

res = requests.post(url=url,
  headers={
    "Content-Type": "application/json;charset=uf8",
    "Appid": app_id,
    "Sign": server_sign,
    "Timestamp": f"{timestamp}"},
  data=body
  )
print(res.json())
    `,
      example_code2: `# Python 3.9
import json
import time
import hmac
import hashlib
import binascii
import requests

app_id = "*** your app_id ***"
app_secret = "*** your app_secret ***"
url = "https://ccpayment.com/ccpayment/v2/getCoin"
content = {"coinId": 1280} 

timestamp = int(time.time())
body = json.dumps(content)
sign_text = f"{app_id}{timestamp}"
if len(body) != 2:
  sign_text = f"{sign_text}{body}"
else:
  body = ""

h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
server_sign = binascii.hexlify(h.digest()).decode('utf-8')

res = requests.post(url=url,
  headers={
    "Content-Type": "application/json;charset=uf8",
    "Appid": app_id,
    "Sign": server_sign,
    "Timestamp": f"{timestamp}"},
  data=body
  )
print(res.json())`,
    },
    go: {
      http_ex_code: `h := hmac.New(sha256.New, []byte(AppSecret))
h.Write([]byte("The quick brown fox jumped over the lazy dog."))
serverSign := hex.EncodeToString(h.Sum(nil)[:])`,
      example_code: `package main

import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "fmt"
    "io"
    "net/http"
    "time"
)

func main() {

    appId := "*** your appId ***"
    appSecret := "*** your appSecret ***"

    // With request params
    path := "https://ccpayment.com/ccpayment/v2/getCoinList" //TODO 替换域名
    args := []byte("")                                                                //TODO 替换参数

    //sign
    timestamp := time.Now().Unix()
    signText := fmt.Sprintf("%s%d", appId, timestamp)
    if len(args) != 0 {
        signText = fmt.Sprintf("%s%s", signText, args)
    }

    h := hmac.New(sha256.New, []byte(appSecret))
    h.Write([]byte(signText))
    sign := hex.EncodeToString(h.Sum(nil)[:])

    fmt.Println("Sign: %s", sign)

    // Making API call
    client := http.Client{}
    request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
    request.Header.Set("Appid", appId)
    request.Header.Set("Sign", sign)
    request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))

    resp, _ := client.Do(request)

    defer resp.Body.Close()
    respBytes, _ := io.ReadAll(resp.Body)
    fmt.Println("Resp: %s", respBytes)
}`,
      example_code2: `package main

import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "fmt"
    "io"
    "net/http"
    "time"
)

func main() {

    appId := "*** your appId ***"
    appSecret := "*** your appSecret ***"

    // With request params
    path := "https://ccpayment.com/ccpayment/v2/getCoin"
    args := []byte(${'`{"coinId":1280}`'})

    //sign
    timestamp := time.Now().Unix()

    signText := fmt.Sprintf("%s%d", appId, timestamp)
    if len(args) != 0 {
        signText = fmt.Sprintf("%s%s", signText, args)
    }

    h := hmac.New(sha256.New, []byte(appSecret))
    h.Write([]byte(signText))
    sign := hex.EncodeToString(h.Sum(nil)[:])

    fmt.Println("Sign: %s", sign)

    // Making API call
    client := http.Client{}
    request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
    request.Header.Set("Appid", appId)
    request.Header.Set("Sign", sign)
    request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))

    resp, _ := client.Do(request)

    defer resp.Body.Close()
    respBytes, _ := io.ReadAll(resp.Body)
    fmt.Println("Resp: %s", respBytes)
}`,
    },
    php: {
      http_ex_code: `hash_hmac('sha256', 'The quick brown fox jumped over the lazy dog.', 'AppSecret');`,
      example_code: `<?php
$app_id = "*** your app_id ***";
$app_secret = "*** your app_secret ***";
$url = "https://ccpayment.com/ccpayment/v2/getCoinList";
$content = array();

$timestamp = time();
$body = json_encode($content);
$sign_text = $app_id . $timestamp;
if (strlen($body) != 2) {
    $sign_text = $sign_text . $body;
} else {
    $body = "";
}

$server_sign = hash_hmac('sha256', $sign_text, $app_secret);

$data = array(
  "headers" => array(
    "Content-Type: application/json;charset=utf-8",
    "Appid: " . $app_id,
    "Sign: " . $server_sign,
    "Timestamp: " . $timestamp
  ),
  "body" => $body
);

$ch = curl_init();
curl_setopt($ch, CURLOPT_URL, $url);
curl_setopt($ch, CURLOPT_POST, true);
curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);

$response = curl_exec($ch);
curl_close($ch);

$result = json_decode($response, true);
print_r($result);
?>`,
      example_code2: `<?php
$app_id = "*** your app_id ***";
$app_secret = "*** your app_secret ***";
$url = "https://ccpayment.com/ccpayment/v2/getCoin";
$content = ['coinId'=>1280];

$timestamp = time();
$body = json_encode($content);
$sign_text = $app_id . $timestamp;
if (strlen($body) != 2) {
    $sign_text = $sign_text . $body;
} else {
    $body = "";
}

$server_sign = hash_hmac('sha256', $sign_text, $app_secret);

$data = array(
    "headers" => array(
        "Content-Type: application/json;charset=utf-8",
        "Appid: " . $app_id,
        "Sign: " . $server_sign,
        "Timestamp: " . $timestamp
    ),
    "body" => $body
);

$ch = curl_init();
curl_setopt($ch, CURLOPT_URL, $url);
curl_setopt($ch, CURLOPT_POST, true);
curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);

$response = curl_exec($ch);
curl_close($ch);

$result = json_decode($response, true);
print_r($result);
?>`,
    },
    java: {
      http_ex_code: `private static String Sign(String appId, String appSecret, String inputString) throws NoSuchAlgorithmException, InvalidKeyException {
    byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
    // s
    long timestamp = new Date().getTime() / 1000L;
    
    String signText = appId + timestamp;
    if (requestBody.length != 0) {
        signText += new String(requestBody, StandardCharsets.UTF_8);
    }
    Mac sha256Hmac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    sha256Hmac.init(secretKey);
    byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));

    StringBuilder hs = new StringBuilder();
    String tempStr;
    for (int index = 0; signBytes != null && index < signBytes.length; index++) {
        tempStr = Integer.toHexString(signBytes[index] & 0XFF);
      if (tempStr.length() == 1) {
          hs.append('0');
      }
        hs.append(tempStr);
    }

    return hs.toString().toLowerCase();
}`,
      example_code: `package com.CCPayment.apis;

import java.nio.charset.StandardCharsets;
import java.security.InvalidKeyException;
import java.security.NoSuchAlgorithmException;
import javax.crypto.Mac;
import javax.crypto.spec.SecretKeySpec;

import com.fasterxml.jackson.databind.ObjectMapper;
import com.fasterxml.jackson.databind.SerializationFeature;
import org.apache.http.HttpResponse;
import org.apache.http.client.HttpClient;
import org.apache.http.client.methods.HttpPost;
import org.apache.http.entity.ByteArrayEntity;
import org.apache.http.impl.client.HttpClientBuilder;
import java.io.BufferedReader;
import java.io.IOException;
import java.io.InputStreamReader;
import java.util.Date;
import java.util.HashMap;
import java.util.Map;

public class paymentApi {
    public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
        String appId = "*** your appId ***";
        String appSecret = "*** your appSecret ***";
        // With request params
        String path = "https://ccpayment.com/ccpayment/v2/getCoinList";

        byte[] requestBody = "".getBytes(StandardCharsets.UTF_8);
        // Sign
        long timestamp = new Date().getTime() / 1000L;
        String signText = appId + timestamp;
        if (requestBody.length != 0) {
            signText += new String(requestBody, StandardCharsets.UTF_8);
        }
        Mac sha256Hmac = Mac.getInstance("HmacSHA256");
        SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
        sha256Hmac.init(secretKey);
        byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
        String sign = byteArrayToHexString(signBytes);

        // Making API call
        HttpClient client = HttpClientBuilder.create().build();
        HttpPost request = new HttpPost(path);
        request.setHeader("Appid", appId);
        request.setHeader("Sign", sign);
        request.setHeader("Timestamp", String.valueOf(timestamp));
        request.setEntity(new ByteArrayEntity(requestBody));
        HttpResponse response = client.execute(request);
        BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
        StringBuilder responseText = new StringBuilder();
        String line;
        while ((line = reader.readLine()) != null) {
            responseText.append(line);
        }
        reader.close();

        // result
        System.out.println("Resp: " + responseText);
    }

    private static String byteArrayToHexString(byte[] bytes) {
        StringBuilder hs = new StringBuilder();
        String tempStr;
        for (int index = 0; bytes != null && index < bytes.length; index++) {
            tempStr = Integer.toHexString(bytes[index] & 0XFF);
            if (tempStr.length() == 1) {
                hs.append('0');
            }
            hs.append(tempStr);
        }
        return hs.toString().toLowerCase();
    }
}`,
      example_code2: `package com.CCPayment.apis;

import java.nio.charset.StandardCharsets;
import java.security.InvalidKeyException;
import java.security.NoSuchAlgorithmException;
import javax.crypto.Mac;
import javax.crypto.spec.SecretKeySpec;

import com.fasterxml.jackson.databind.ObjectMapper;
import com.fasterxml.jackson.databind.SerializationFeature;
import org.apache.http.HttpResponse;
import org.apache.http.client.HttpClient;
import org.apache.http.client.methods.HttpPost;
import org.apache.http.entity.ByteArrayEntity;
import org.apache.http.impl.client.HttpClientBuilder;
import java.io.BufferedReader;
import java.io.IOException;
import java.io.InputStreamReader;
import java.util.Date;
import java.util.HashMap;
import java.util.Map;

public class paymentApi {
    public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
        String appId = "*** your appId ***";
        String appSecret = "*** your appSecret ***";
        // With request params
        String path = "https://ccpayment.com/ccpayment/v2/getCoin";

        // params
        Map<String, Object> map = new HashMap<>();
        map.put("coinId", 1280);

        ObjectMapper mapper = new ObjectMapper();
        mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
        String inputString = mapper.writeValueAsString(map);

        byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
        // Sign
        long timestamp = new Date().getTime() / 1000L;
        String signText = appId + timestamp;
        if (requestBody.length != 0) {
            signText += new String(requestBody, StandardCharsets.UTF_8);
        }
        Mac sha256Hmac = Mac.getInstance("HmacSHA256");
        SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
        sha256Hmac.init(secretKey);
        byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
        String sign = byteArrayToHexString(signBytes);

        // Making API call
        HttpClient client = HttpClientBuilder.create().build();
        HttpPost request = new HttpPost(path);
        request.setHeader("Appid", appId);
        request.setHeader("Sign", sign);
        request.setHeader("Timestamp", String.valueOf(timestamp));
        request.setEntity(new ByteArrayEntity(requestBody));
        HttpResponse response = client.execute(request);
        BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
        StringBuilder responseText = new StringBuilder();
        String line;
        while ((line = reader.readLine()) != null) {
            responseText.append(line);
        }
        reader.close();

        // result
        System.out.println("Resp: " + responseText);
    }

    private static String byteArrayToHexString(byte[] bytes) {
        StringBuilder hs = new StringBuilder();
        String tempStr;
        for (int index = 0; bytes != null && index < bytes.length; index++) {
            tempStr = Integer.toHexString(bytes[index] & 0XFF);
            if (tempStr.length() == 1) {
                hs.append('0');
            }
            hs.append(tempStr);
        }
        return hs.toString().toLowerCase();
    }
}`,
    },
  };

  const codeMap_: { [key: string]: any } = {
    javascript: {
      http_ex_code: `// Prepare data to be signed
    const dataToSign = apiID + timestamp + apiParams;

    // Load the private key
    const privateKey = crypto.createPrivateKey(privateKeyPem);

    // Sign the data
    const sign = crypto.createSign('SHA256');
    sign.update(dataToSign);
    sign.end();

    const signature = sign.sign(privateKey, 'base64');`,
      example_code: `const crypto = require('crypto');
const https = require('https');

// Usage example
const apiID = "*** your app_id ***";
const privateKeyPem = ${"`"}-----BEGIN PRIVATE KEY-----
*** your PRIVATE KEY ***
-----END PRIVATE KEY-----${"`"}
const apiParams = "";
const apiPath = "https://ccpayment.com/ccpayment/v2/getCoinList";

(async () => {
  try {
    const response = await signWithPrivateKey(apiID, privateKeyPem, apiParams, apiPath);
    console.log("Response:", response);
  } catch (err) {
    console.error("Error:", err);
  }
})();

function signWithPrivateKey(apiID, privateKeyPem, apiParams, apiPath) {
  return new Promise((resolve, reject) => {
    // Calculate the timestamp
    const timestamp = Math.floor(Date.now() / 1000).toString();

    // Prepare data to be signed
    const dataToSign = apiID + timestamp + apiParams;

    // Load the private key
    const privateKey = crypto.createPrivateKey(privateKeyPem);

    // Sign the data
    const sign = crypto.createSign('SHA256');
    sign.update(dataToSign);
    sign.end();

    const signature = sign.sign(privateKey, 'base64');

    // Send the request
    const postData = apiParams;

    const url = new URL(apiPath);
    const options = {
      hostname: url.hostname,
      path: url.pathname + url.search,
      method: 'POST',
      headers: {
        'Appid': apiID,
        'Sign': signature,
        'Timestamp': timestamp,
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    };

    const req = https.request(options, (res) => {
      let data = '';

      // Collect response data
      res.on('data', (chunk) => {
        data += chunk;
      });

      // Resolve the response when it ends
      res.on('end', () => {
        resolve(data);
      });
    });

    // Handle request error
    req.on('error', (e) => {
      reject(e);
    });

    // Write POST data
    req.write(postData);
    req.end();
  });
}
`,
      example_code2: `const https = require('https');
const crypto = require('crypto');

const appId ='*** your appId ***';
const appSecret ='*** your appSecret ***';

const path = 'https://ccpayment.com/ccpayment/v2/getCoin';
const args = JSON.stringify({ "coinId": 1280 });

const timestamp = Math.floor(Date.now() / 1000);
let signText = appId + timestamp;
if (args) {
  signText += args;
}

const sign = crypto
  .createHmac('sha256', appSecret)
  .update(signText)
  .digest('hex');

const options = {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Appid': appId,
    'Sign': sign,
    'Timestamp': timestamp.toString(),
  },
};

const req = https.request(path, options, (res) => {
  let respData = '';

  res.on('data', (chunk) => {
    respData += chunk;
  });

  res.on('end', () => {
    console.log('Response:', respData);
  });
});

req.write(args);
req.end();`,
    },
    python: {
      http_ex_code: `# Prepare data to sign
    data_to_sign = api_id + timestamp + api_params

    # Load private key
    private_key = serialization.load_pem_private_key(
        private_key_pem.encode(),
        password=None,
        backend=default_backend()
    )

    # Sign the data
    signature = private_key.sign(
        data_to_sign.encode(),
        padding.PKCS1v15(),
        hashes.SHA256()
    )

    # Encode signature in base64
    data_to_sign = base64.b64encode(signature).decode()`,
      example_code: `import time
import base64
import requests
from cryptography.hazmat.primitives import serialization, hashes
from cryptography.hazmat.primitives.asymmetric import padding
from cryptography.hazmat.backends import default_backend


def sign_with_private_key(api_id, private_key_pem, api_params, api_path):
    # Calculate timestamp
    timestamp = str(int(time.time()))

    # Prepare data to sign
    data_to_sign = api_id + timestamp + api_params

    # Load private key
    private_key = serialization.load_pem_private_key(
        private_key_pem.encode(),
        password=None,
        backend=default_backend()
    )

    # Sign the data
    signature = private_key.sign(
        data_to_sign.encode(),
        padding.PKCS1v15(),
        hashes.SHA256()
    )

    # Encode signature in base64
    signature_base64 = base64.b64encode(signature).decode()

    # Send request
    headers = {
        "Appid": api_id,
        "Sign": signature_base64,
        "Timestamp": timestamp
    }
    response = requests.post(api_path, headers=headers, data=api_params)
    return response.json()


if __name__ == '__main__':
    # Usage example
    api_id = "*** your app_id ***"
    private_key_pem = """*** your PRIVATE KEY ***"""
    api_params = ""
    api_path = "https://ccpayment.com/ccpayment/v2/getCoinList"
    response = sign_with_private_key(api_id, private_key_pem, api_params, api_path)
    print(response)`,
      example_code2: `import time
import base64
import requests
from cryptography.hazmat.primitives import serialization, hashes
from cryptography.hazmat.primitives.asymmetric import padding
from cryptography.hazmat.backends import default_backend


def sign_with_private_key(api_id, private_key_pem, api_params, api_path):
    # Calculate timestamp
    timestamp = str(int(time.time()))

    # Prepare data to sign
    data_to_sign = api_id + timestamp + api_params

    # Load private key
    private_key = serialization.load_pem_private_key(
        private_key_pem.encode(),
        password=None,
        backend=default_backend()
    )

    # Sign the data
    signature = private_key.sign(
        data_to_sign.encode(),
        padding.PKCS1v15(),
        hashes.SHA256()
    )

    # Encode signature in base64
    signature_base64 = base64.b64encode(signature).decode()

    # Send request
    headers = {
        "Appid": api_id,
        "Sign": signature_base64,
        "Timestamp": timestamp
    }
    response = requests.post(api_path, headers=headers, data=api_params)
    return response.json()


if __name__ == '__main__':
    # Usage example
    api_id = "*** your app_id ***"
    private_key_pem = """*** your PRIVATE KEY ***"""
    api_params = ""
    api_path = "https://ccpayment.com/ccpayment/v2/getCoinList"
    response = sign_with_private_key(api_id, private_key_pem, api_params, api_path)
    print(response)`,
    },
    go: {
      http_ex_code: `// Prepare data to sign
    dataToSign := apiID + timestamp + apiParams

    // Sign the data
    hashed := sha256.Sum256([]byte(dataToSign))
    signature, err := rsa.SignPKCS1v15(rand.Reader, rsaPrivateKey, crypto.SHA256, hashed[:])
    if err != nil {
        return "", err
    }

    // Encode signature in base64
    signatureBase64 := base64.StdEncoding.EncodeToString(signature)`,
      example_code: `package main

import (
    "crypto"
    "crypto/rand"
    "crypto/rsa"
    "crypto/sha256"
    "crypto/x509"
    "encoding/base64"
    "encoding/pem"
    "fmt"
    "io/ioutil"
    "net/http"
    "strings"
    "time"
)

func main() {
    // Usage example
    apiID := "*** your app_id ***"
    privateKeyPem := ${"`"}-----BEGIN PRIVATE KEY-----
*** your PRIVATE KEY ***
-----END PRIVATE KEY-----${"`"}
    apiParams := ""
    apiPath := "https://ccpayment.com/ccpayment/v2/getCoinList"

    response, err := signWithPrivateKey(apiID, privateKeyPem, apiParams, apiPath)
    if err != nil {
        fmt.Println("Error:", err)
    } else {
        fmt.Println("Response:", response)
    }
}

func signWithPrivateKey(apiID, privateKeyPem, apiParams, apiPath string) (string, error) {
    // Calculate timestamp
    timestamp := fmt.Sprintf("%d", time.Now().Unix())

    // Prepare data to sign
    dataToSign := apiID + timestamp + apiParams

    // Load private key
    privateKey, err := loadPrivateKey(privateKeyPem)
    if err != nil {
        return "", err
    }

    // Sign the data
    hashed := sha256.Sum256([]byte(dataToSign))
    signature, err := rsa.SignPKCS1v15(rand.Reader, privateKey, crypto.SHA256, hashed[:])
    if err != nil {
        return "", err
    }

    // Encode signature in base64
    signatureBase64 := base64.StdEncoding.EncodeToString(signature)

    // Send request
    req, err := http.NewRequest("POST", apiPath, strings.NewReader(apiParams))
    if err != nil {
        return "", err
    }

    req.Header.Set("Appid", apiID)
    req.Header.Set("Sign", signatureBase64)
    req.Header.Set("Timestamp", timestamp)

    client := &http.Client{}
    resp, err := client.Do(req)
    if err != nil {
        return "", err
    }
    defer resp.Body.Close()

    body, err := ioutil.ReadAll(resp.Body)
    if err != nil {
        return "", err
    }

    return string(body), nil
}

func loadPrivateKey(privateKeyPem string) (*rsa.PrivateKey, error) {
    block, _ := pem.Decode([]byte(privateKeyPem))
    if block == nil || block.Type != "PRIVATE KEY" {
        return nil, fmt.Errorf("failed to decode PEM block containing private key")
    }

    privateKey, err := x509.ParsePKCS8PrivateKey(block.Bytes)
    if err != nil {
        return nil, fmt.Errorf("failed to parse private key: %v", err)
    }

    rsaPrivateKey, ok := privateKey.(*rsa.PrivateKey)
    if !ok {
        return nil, fmt.Errorf("not an RSA private key")
    }

    return rsaPrivateKey, nil
}
`,
      example_code2: `package main

import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "fmt"
    "io"
    "net/http"
    "time"
)

func main() {

    appId := "*** your appId ***"
    appSecret := "*** your appSecret ***"

    // With request params
    path := "https://ccpayment.com/ccpayment/v2/getCoin"
    args := []byte(${'`{"coinId":1280}`'})

    //sign
    timestamp := time.Now().Unix()

    signText := fmt.Sprintf("%s%d", appId, timestamp)
    if len(args) != 0 {
        signText = fmt.Sprintf("%s%s", signText, args)
    }

    h := hmac.New(sha256.New, []byte(appSecret))
    h.Write([]byte(signText))
    sign := hex.EncodeToString(h.Sum(nil)[:])

    fmt.Println("Sign: %s", sign)

    // Making API call
    client := http.Client{}
    request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
    request.Header.Set("Appid", appId)
    request.Header.Set("Sign", sign)
    request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))

    resp, _ := client.Do(request)

    defer resp.Body.Close()
    respBytes, _ := io.ReadAll(resp.Body)
    fmt.Println("Resp: %s", respBytes)
}`,
    },
    php: {
      http_ex_code: `$timestamp = time();

  $dataToSign = $apiID . $timestamp . $apiParams;

  $privateKey = openssl_pkey_get_private($privateKeyPem);
  $signature = '';
  openssl_sign($dataToSign, $signature, $privateKey, OPENSSL_ALGO_SHA256);

  $signatureBase64 = base64_encode($signature);`,
      example_code: `<?php

function main() {
    $apiID = "*** your app_id ***";
    $privateKeyPem = <<<EOD
-----BEGIN PRIVATE KEY-----
*** your PRIVATE KEY ***
-----END PRIVATE KEY-----
EOD;
    $apiParams = "";
    $apiPath = "https://ccpayment.com/ccpayment/v2/getCoinList";

    try {
        $response = signWithPrivateKey($apiID, $privateKeyPem, $apiParams, $apiPath);
        echo "Response: " . $response;
    } catch (Exception $e) {
        echo "Error: " . $e->getMessage();
    }
}

function signWithPrivateKey($apiID, $privateKeyPem, $apiParams, $apiPath) {

    $timestamp = time();

    $dataToSign = $apiID . $timestamp . $apiParams;

    $privateKey = loadPrivateKey($privateKeyPem);

    $signature = '';
    openssl_sign($dataToSign, $signature, $privateKey, OPENSSL_ALGO_SHA256);

    $signatureBase64 = base64_encode($signature);

    // send post
    $options = [
        'http' => [
            'header'  => [
                "Content-type: application/x-www-form-urlencoded",
                "Appid: " . $apiID,
                "Sign: " . $signatureBase64,
                "Timestamp: " . $timestamp
            ],
            'method'  => 'POST',
            'content' => $apiParams,
        ],
    ];
    $context  = stream_context_create($options);
    $result = file_get_contents($apiPath, false, $context);

    if ($result === FALSE) {
        throw new Exception("Error processing request");
    }

    return $result;
}

function loadPrivateKey($privateKeyPem) {
    $privateKey = openssl_pkey_get_private($privateKeyPem);
    if ($privateKey === false) {
        throw new Exception("Failed to load private key");
    }
    return $privateKey;
}

main();
?>
`,
      example_code2: `<?php
$app_id = "*** your app_id ***";
$app_secret = "*** your app_secret ***";
$url = "https://ccpayment.com/ccpayment/v2/getCoin";
$content = ['coinId'=>1280];

$timestamp = time();
$body = json_encode($content);
$sign_text = $app_id . $timestamp;
if (strlen($body) != 2) {
    $sign_text = $sign_text . $body;
} else {
    $body = "";
}

$server_sign = hash_hmac('sha256', $sign_text, $app_secret);

$data = array(
    "headers" => array(
        "Content-Type: application/json;charset=utf-8",
        "Appid: " . $app_id,
        "Sign: " . $server_sign,
        "Timestamp: " . $timestamp
    ),
    "body" => $body
);

$ch = curl_init();
curl_setopt($ch, CURLOPT_URL, $url);
curl_setopt($ch, CURLOPT_POST, true);
curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);

$response = curl_exec($ch);
curl_close($ch);

$result = json_decode($response, true);
print_r($result);
?>`,
    },
    java: {
      http_ex_code: `public static String signWithPrivateKey(String apiId, String privateKeyPem, String apiParams, String apiPath) throws Exception {
        // Calculate timestamp
        String timestamp = String.valueOf(System.currentTimeMillis() / 1000);

        // Prepare data to sign
        String dataToSign = apiId + timestamp + apiParams;

        // Load private key
        PrivateKey privateKey = loadPrivateKey(privateKeyPem);

        // Sign the data
        Signature signature = Signature.getInstance("SHA256withRSA");
        signature.initSign(privateKey);
        signature.update(dataToSign.getBytes(StandardCharsets.UTF_8));
        byte[] signatureBytes = signature.sign();

        // Encode signature in base64
        String signatureBase64 = Base64.getEncoder().encodeToString(signatureBytes);
        retrun signatureBase64;
}


    private static PrivateKey loadPrivateKey(String privateKeyPem) throws Exception {
        // Remove PEM header and footer
        privateKeyPem = privateKeyPem.replace("-----BEGIN PRIVATE KEY-----", "")
                .replace("-----END PRIVATE KEY-----", "")
                .replaceAll("\\s", "");

        // Decode base64
        byte[] privateKeyBytes = Base64.getDecoder().decode(privateKeyPem);

        // Convert to PrivateKey object
        PKCS8EncodedKeySpec keySpec = new PKCS8EncodedKeySpec(privateKeyBytes);
        KeyFactory keyFactory = KeyFactory.getInstance("RSA");
        return keyFactory.generatePrivate(keySpec);
    }`,
      example_code: `import java.security.KeyFactory;
import java.security.PrivateKey;
import java.security.Signature;
import java.security.spec.PKCS8EncodedKeySpec;
import java.util.Base64;
import java.nio.charset.StandardCharsets;
import java.net.HttpURLConnection;
import java.net.URL;
import java.io.OutputStream;

public class SignWithPrivateKey {

    public static void main(String[] args) {
        try {
            // Usage example
            String apiId = "*** your app_id ***";
            String privateKeyPem = """
                    *** your PRIVATE KEY ***""";
            String apiParams = "";
            String apiPath = "https://ccpayment.com/ccpayment/v2/getCoinList";

            String response = signWithPrivateKey(apiId, privateKeyPem, apiParams, apiPath);
            System.out.println(response);
        } catch (Exception e) {
            e.printStackTrace();
        }
    }

    public static String signWithPrivateKey(String apiId, String privateKeyPem, String apiParams, String apiPath) throws Exception {
        // Calculate timestamp
        String timestamp = String.valueOf(System.currentTimeMillis() / 1000);

        // Prepare data to sign
        String dataToSign = apiId + timestamp + apiParams;

        // Load private key
        PrivateKey privateKey = loadPrivateKey(privateKeyPem);

        // Sign the data
        Signature signature = Signature.getInstance("SHA256withRSA");
        signature.initSign(privateKey);
        signature.update(dataToSign.getBytes(StandardCharsets.UTF_8));
        byte[] signatureBytes = signature.sign();

        // Encode signature in base64
        String signatureBase64 = Base64.getEncoder().encodeToString(signatureBytes);

        // Send request
        URL url = new URL(apiPath);
        HttpURLConnection conn = (HttpURLConnection) url.openConnection();
        conn.setRequestMethod("POST");
        conn.setRequestProperty("Appid", apiId);
        conn.setRequestProperty("Sign", signatureBase64);
        conn.setRequestProperty("Timestamp", timestamp);
        conn.setDoOutput(true);

        try (OutputStream os = conn.getOutputStream()) {
            os.write(apiParams.getBytes(StandardCharsets.UTF_8));
            os.flush();
        }

        // Get response
        int responseCode = conn.getResponseCode();
        if (responseCode == HttpURLConnection.HTTP_OK) {
            return new String(conn.getInputStream().readAllBytes(), StandardCharsets.UTF_8);
        } else {
            return "Error: " + responseCode;
        }
    }
}`,
      example_code2: `package com.CCPayment.apis;

import java.nio.charset.StandardCharsets;
import java.security.InvalidKeyException;
import java.security.NoSuchAlgorithmException;
import javax.crypto.Mac;
import javax.crypto.spec.SecretKeySpec;

import com.fasterxml.jackson.databind.ObjectMapper;
import com.fasterxml.jackson.databind.SerializationFeature;
import org.apache.http.HttpResponse;
import org.apache.http.client.HttpClient;
import org.apache.http.client.methods.HttpPost;
import org.apache.http.entity.ByteArrayEntity;
import org.apache.http.impl.client.HttpClientBuilder;
import java.io.BufferedReader;
import java.io.IOException;
import java.io.InputStreamReader;
import java.util.Date;
import java.util.HashMap;
import java.util.Map;

public class paymentApi {
    public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
        String appId = "*** your appId ***";
        String appSecret = "*** your appSecret ***";
        // With request params
        String path = "https://ccpayment.com/ccpayment/v2/getCoin";

        // params
        Map<String, Object> map = new HashMap<>();
        map.put("coinId", 1280);

        ObjectMapper mapper = new ObjectMapper();
        mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
        String inputString = mapper.writeValueAsString(map);

        byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
        // Sign
        long timestamp = new Date().getTime() / 1000L;
        String signText = appId + timestamp;
        if (requestBody.length != 0) {
            signText += new String(requestBody, StandardCharsets.UTF_8);
        }
        Mac sha256Hmac = Mac.getInstance("HmacSHA256");
        SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
        sha256Hmac.init(secretKey);
        byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
        String sign = byteArrayToHexString(signBytes);

        // Making API call
        HttpClient client = HttpClientBuilder.create().build();
        HttpPost request = new HttpPost(path);
        request.setHeader("Appid", appId);
        request.setHeader("Sign", sign);
        request.setHeader("Timestamp", String.valueOf(timestamp));
        request.setEntity(new ByteArrayEntity(requestBody));
        HttpResponse response = client.execute(request);
        BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
        StringBuilder responseText = new StringBuilder();
        String line;
        while ((line = reader.readLine()) != null) {
            responseText.append(line);
        }
        reader.close();

        // result
        System.out.println("Resp: " + responseText);
    }

    private static String byteArrayToHexString(byte[] bytes) {
        StringBuilder hs = new StringBuilder();
        String tempStr;
        for (int index = 0; bytes != null && index < bytes.length; index++) {
            tempStr = Integer.toHexString(bytes[index] & 0XFF);
            if (tempStr.length() == 1) {
                hs.append('0');
            }
            hs.append(tempStr);
        }
        return hs.toString().toLowerCase();
    }
}`,
    },
  };

  return (
    <>
      <Box
        sx={{
          background: "#1F2025 !important",
          borderRadius: "16px",
          maxHeight: "482px",
          overflow: "auto",
          "::-webkit-scrollbar": {
            display: "none",
            width: "6px",
            height: "6px",
            backgroundColor: "#1F2025",
            borderRadius: "12px",
          },

          "::-webkit-scrollbar-thumb": {
            borderRadius: "12px",
            backgroundColor: "#282b31",
          },
        }}
      >
        <CodeSnippet
          title={translate("common.http_ex_HMAC")}
          code={codeMap[language].http_ex_code}
          sx={{
            mb: 3,
          }}
        />
        <CodeSnippet
          title={
            <>
              {translate("quick_start.example_title1")}
              <br />
              {translate("quick_start.example_title2")}
            </>
          }
          code={codeMap[language].example_code}
          sx={{
            mb: 3,
          }}
        />
        <CodeSnippet
          title={translate("quick_start.example_title3")}
          code={codeMap[language].example_code2}
        />
      </Box>
      <Box
        sx={{
          background: "#1F2025 !important",
          borderRadius: "16px",
          maxHeight: "482px",
          overflow: "auto",
          "::-webkit-scrollbar": {
            display: "none",
            width: "6px",
            height: "6px",
            backgroundColor: "#1F2025",
            borderRadius: "12px",
          },

          "::-webkit-scrollbar-thumb": {
            borderRadius: "12px",
            backgroundColor: "#282b31",
          },
        }}
        mt={3}
      >
        {/* RSA */}
        <CodeSnippet
          title={translate("common.http_ex_RSA")}
          code={codeMap_[language].http_ex_code}
          sx={{
            mb: 3,
          }}
        />
        <CodeSnippet
          title={
            <>
              {translate("quick_start.example_title1")}
              <br />
              {translate("quick_start.example_title4")}
            </>
          }
          code={codeMap_[language].example_code}
        />
      </Box>
    </>
  );
};

const NoCodeContent = () => {
  const { translate } = useLocales();
  // const { UserInfo } = merchantStroe;
  return (
    <>
      <Box id="quick-guide" component={"div"} className="title">
        {translate("quick_start.title1")}
      </Box>
      <Box mb={3} />

      <Box mb={3}>
        <Box component={"div"} className="title_0" id="credentials">
          {translate("quick_start.start_title1")}
        </Box>
        <Box component={"div"} className="desc">
          {translate("quick_start.start_title1_desc")}
        </Box>
      </Box>

      <Box mb={3}>
        <Box component={"div"} className="title_0">
          {translate("quick_start.start_title2")}
        </Box>
        <Box component={"div"} className="desc">
          <Trans
            i18nKey={"quick_start.start_title2_desc1"}
            t={translate as any}
          >
            s
            <Link
              href={ADMIN_REGISTER_URL}
              target="_blank"
              className="link"
              underline="always"
            >
              {translate("common.register")}
            </Link>
            s
          </Trans>
        </Box>
        <Box component={"div"} className="desc">
          <Trans
            i18nKey={"quick_start.start_title2_desc2"}
            t={translate as any}
          >
            s<strong>s</strong>
            <strong>s</strong>
            <strong>s</strong>s
          </Trans>
        </Box>
      </Box>

      {true && (
        <>
          <Box
            id="api-authentication-and-specifications"
            component={"div"}
            className="title_0"
          >
            {translate("quick_start.title2")}
          </Box>
          <Box component={"div"} className="desc">
            {translate("quick_start.title2_desc")}
          </Box>
        </>
      )}
    </>
  );
};
